export type prefix = 'ana' | 'adm' | 'common' | 'marketplace' | 'admin' | 'pbs' | 'settings'
export type label = string
type action =
  | 'view'
  | 'new'
  | 'clone'
  | 'edit'
  | 'save'
  | 'archive'
  | 'unarchive'
  | 'help'
  | 'download'
  | 'upload'
  | 'confirm'
  | 'cancel'
  | 'set'
  | 'unset'
  | 'apply'
  | 'back'
  | 'continue'
  | 'previous'
  | 'next'
  | 'restore'
  | 'navigate'
  | 'refresh'
  | 'delete'
  | 'copy'
  | 'close'
  | 'request'
  | 'setup'
  | 'verify'

export type TrackingLabel = `${prefix}-${label}-${action}`

export const normalizeAsTrackingLabel = (text: string) => text.toLocaleLowerCase().replaceAll(/[ _:]/g, '-').replaceAll(/[.\/]/g, '').replaceAll(/--/g, '-')
